import { useState, useEffect, useCallback } from "react";
import { get } from "../utils/api";

const useFetch = (url) => {
    const [fetchedData, setFetchedData] = useState({
        data: [],
        totalCount: 10,
        isLoading: true,
        error: "",
    });

    const fetchData = useCallback(async () => {
        try {
            // Cookie-based auth: the httpOnly token cookie is sent automatically
            // (axios client has withCredentials: true), so no token is needed here.
            const response = await get(url);
            const { data, status } = response;    

            if (status >= 400) {
                setFetchedData({
                    data: [],
                    totalCount: 0,
                    isLoading: false,
                    error: data.message,
                });
            } else {
                if (status === 200) {
                    setFetchedData({
                        data: data.data || data,  // Handle both response formats
                        totalCount: data.pagination?.total || data.pagination?.totalPages * 10 || 0,
                        isLoading: false,
                        error: "",
                    });
                } else if (status >= 400) {
                    setFetchedData({
                        data: [],
                        totalCount: 0,
                        isLoading: false,
                        error: "row count or current page should not be null",
                    });
                }
            }
        } catch (err) {
            setFetchedData({
                data: [],
                totalCount: 0,
                isLoading: false,
                error: err.message,
            });
        }
    }, [url]);

    useEffect(() => {
        fetchData();
    }, [url, fetchData]);

    const { data, totalCount, isLoading, error } = fetchedData;
    return { data, totalCount, isLoading, error };
};

export default useFetch;